<div class="flex-auto">
  <button class="cursor-pointer" data-testid="account-menu-toggle" (click)="menu.toggle($event)">
    @if (userImage()) {
      <p-avatar [image]="userImage()" class="mr-2" shape="circle" />
    } @else {
      <p-avatar icon="pi pi-user" class="mr-2" shape="circle" />
    }
  </button>
  <p-menu
    #menu
    [model]="menuItems()"
    class="flex justify-center"
    styleClass="w-full md:w-60"
    [popup]="true"
  >
    <ng-template #start>
      <button
        pRipple
        class="relative overflow-hidden w-full border-0 bg-transparent flex items-start p-2 pl-4 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-none cursor-pointer transition-colors duration-200"
      >
        <span class="inline-flex flex-col items-start">
          <span class="font-bold">{{ userName() }}</span>
          <span class="text-sm">{{ userRole() }}</span>
        </span>
      </button>
    </ng-template>
    <ng-template #submenuheader let-item>
      <span class="text-primary font-bold">{{ item.label }}</span>
    </ng-template>
    <ng-template #item let-item>
      <a
        pRipple
        class="flex items-center px-3 py-2 cursor-pointer"
        [class]="item.linkClass"
        [attr.data-testid]="'account-menu-item-' + item.id"
      >
        <span [class]="item.icon"></span>
        <span class="ms-2">{{ item.label }}</span>
      </a>
    </ng-template>
  </p-menu>
</div>
